import { MapData_Base, MapData_Metadata } from '~/common/typescript/models/MapData';

export interface ParsedMapDataMetadata {
  metadata: MapData_Metadata;
  ogrInfo: any;
  gdalInfo: any;
  tileFile: any;
  styleFile: any;
  isVector: boolean;
  isRaster: boolean;
}

export const parseMapDataMetadata = (mapData: MapData_Base): ParsedMapDataMetadata => {
  let metadata: MapData_Metadata = {};
  try {
    metadata = typeof mapData.metadata === 'string' ? JSON.parse(mapData.metadata || '{}') : (mapData.metadata || {});
  } catch {
    metadata = {};
  }

  let ogrInfo: any = null;
  let gdalInfo: any = null;

  const ogrInfoRaw = (metadata as any).ogrInfo || (metadata as any).ogrinfo;
  if (ogrInfoRaw && typeof ogrInfoRaw === 'string' && ogrInfoRaw.trim() !== '') {
    try {
      ogrInfo = JSON.parse(ogrInfoRaw);
    } catch {
      // Raw text output from GDAL/OGR (e.g. DGN or GeoJSON stdout)
      ogrInfo = { raw: ogrInfoRaw };
    }
  } else if (ogrInfoRaw && typeof ogrInfoRaw === 'object') {
    ogrInfo = ogrInfoRaw;
  }

  const gdalInfoRaw = (metadata as any).gdalInfo || (metadata as any).gdalinfo;
  if (gdalInfoRaw && typeof gdalInfoRaw === 'string' && gdalInfoRaw.trim() !== '') {
    try {
      gdalInfo = JSON.parse(gdalInfoRaw);
    } catch {
      gdalInfo = { raw: gdalInfoRaw };
    }
  } else if (gdalInfoRaw && typeof gdalInfoRaw === 'object') {
    gdalInfo = gdalInfoRaw;
  }

  const tileFile = mapData.map_data_files?.find((file: any) => file.type === 'pmtiles' || file.type === 'mbtiles');
  const styleFile = mapData.map_data_files?.find((file: any) => file.type === 'style');

  // Vector vs Raster detection
  const isRaster = (metadata as any).isRaster === true || !!(gdalInfo && !gdalInfo.raw);
  const isVector =
    (metadata as any).isVector === true ||
    !!ogrInfo ||
    !!tileFile ||
    (Boolean((metadata as any).driverShortName) && !isRaster);

  return {
    metadata,
    ogrInfo,
    gdalInfo,
    tileFile,
    styleFile,
    isVector,
    isRaster,
  };
};
